// PFLICHTFELDER für die Provisionsberechnung (Anträge + Policen).
// Krankenkasse (malattia): Prämie, Franchise, KVG Beginn/Ende/Prämie, VVG Beginn/Ende/Prämie.
// Alle anderen Typen: Prämie. Ohne diese Felder ist keine Provision möglich.
export const MANDATORY_LABELS = {
  premium: "Prämie",
  kvg_franchise: "Franchise",
  kvg_start: "KVG Beginn",
  kvg_end: "KVG Ende",
  kvg_premium: "Prämie KVG",
  vvg_start: "VVG Beginn",
  vvg_end: "VVG Ende",
  vvg_premium: "Prämie VVG",
};

export function getMissingMandatoryFields({ insurance_type, premium, details }) {
  const missing = [];
  if (!(parseFloat(premium) > 0)) missing.push("premium");
  if ((insurance_type || "").toLowerCase() === "malattia") {
    const d = details || {};
    if (!String(d.kvg_franchise ?? "").trim()) missing.push("kvg_franchise");
    if (!String(d.kvg_start ?? "").trim()) missing.push("kvg_start");
    if (!String(d.kvg_end ?? "").trim()) missing.push("kvg_end");
    if (!(parseFloat(d.kvg_premium) > 0)) missing.push("kvg_premium");
    if (!String(d.vvg_start ?? "").trim()) missing.push("vvg_start");
    if (!String(d.vvg_end ?? "").trim()) missing.push("vvg_end");
    if (!(parseFloat(d.vvg_premium) > 0)) missing.push("vvg_premium");
  }
  return missing;
}
